import React from 'react'
import { CFooter } from '@coreui/react'

const AppFooter = () => {
  return (
    <CFooter>
     
      <div className="ms-auto">
        {/* <span className="me-1">Developed by</span>
        <a href="https://www.truelinesolution.com/" target="_blank" rel="noopener noreferrer">
        Trueline Solution
        </a>
        <span> | All Rights Reserved</span> */}
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
